import { useCurrentModule } from '../components/ModuleProvider';
import { useAnonymous } from './useAnonymous';
export const useCycleAvailability = (productId, cycle) => {
  var _isCycleAvailableQuer, _lowestCycleAvailable;
  const module = useCurrentModule();
  const {
    isAnonymous
  } = useAnonymous();
  const lowestCycleAvailableQuery = module.SDK.switchApiClient.hooks.useLowestCycleAvailable({
    productId: productId || ''
  }, Boolean(productId));
  const isCycleAvailableQuery = module.SDK.switchApiClient.hooks.useIsCycleAvailable({
    productId: productId || '',
    cycle: cycle || {}
  }, Boolean(productId && cycle));
  const isLoading = isCycleAvailableQuery.isLoading || lowestCycleAvailableQuery.isLoading;
  return {
    // TODO - this need to be change to if we are in downgrade or switch or upgrade then check canPuchase, or put this logic inside the switch module
    isCycleAvailable: isAnonymous || Boolean((_isCycleAvailableQuer = isCycleAvailableQuery.data) == null ? void 0 : _isCycleAvailableQuer.isCycleAvailable),
    lowestCycleAvailable: (_lowestCycleAvailable = lowestCycleAvailableQuery.data) == null ? void 0 : _lowestCycleAvailable.lowestCycleAvailable,
    isLoading
  };
};
//# sourceMappingURL=useCycleAvailability.js.map